import client from './client';

export default {
  blacklist() {
    return client.del('/tokens/self').end();
  },

  create(email, password) {
    return client.post('/tokens')
      .send({
        email: email,
        password: password
      })
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/tokenAPI.js